import React, { useEffect, useState } from 'react'
import Header from '../Header'
import { Card, Col, Container, Form, FormSelect, Image, Row } from 'react-bootstrap'
import { faIndianRupeeSign } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import axios from 'axios'
import ToggleButton from 'react-toggle-button'
import Loader from '../Loader/Loader'
import { toast, ToastContainer } from 'react-toastify'
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { TabView, TabPanel } from 'primereact/tabview';
import { set } from 'react-hook-form'

const Profile = () => {
  const [loading, setLoading] = useState(true);
  const [innerWidth, setInnerWidth] = useState(0);
  const [currentplan, setCurrentPlan] = useState([]);
  const [upcommingPlan, setUpcommingPlan] = useState([]);
  const [expiresOn, setExpiresOn] = useState(null);
  const [parentalOnOFF, setParentalONOFF] = useState(null);
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    fetchData()
    fetchCurrentUpcommingPlans()
    const iw = window.innerWidth
    console.log(iw);
    setInnerWidth(iw)
  }, []);


  const fetchCurrentUpcommingPlans = async () => {
    try {
      const reqData = {
        user_id: localStorage.getItem('user_id') ? localStorage.getItem('user_id') : 0,

      }
      axios.post(`${process.env.REACT_APP_API_URL}/currentUpcommingPlans`, reqData)
        .then((response) => {
          setLoading(false)
          const obj = response.data.data;
          setCurrentPlan(obj.current_plan);
          setUpcommingPlan(obj.upcomming_plan);
          console.log(obj);
        });
    } catch (err) {
      setLoading(false)
      // setError(err);
    } finally {
      // setLoading(false);
    }

  }
  const handleParentalSwitch = async (value) => {
    
    let is_enabled = value ? 1 : 0
    try {
      const reqData = {
        phone: localStorage.getItem('phone') ? localStorage.getItem('phone') : '9999999999',
        is_enabled: is_enabled
      }
      axios.post(`${process.env.REACT_APP_CONTENT_URL}/update-parental-setting`, reqData)
        .then((response) => {
          setLoading(false)
          const obj = response.data;
          console.log(obj);
          if(obj.status === 1)
          {
            setChecked(value)
            toast(obj.msg);
          }
          else{
            toast.error(obj.msg);
          }
          


          // const current_plan = obj.current_plan;
          // const expire_on = obj.expire_on 
        });
    } catch (err) {
      setLoading(false)
      // setError(err);
    } finally {
      // setLoading(false);
    }
  }
  const fetchData = async () => {
    setLoading(true)
    try {
      const reqData = {
        user_id: localStorage.getItem('user_id')
      }
      await axios.post(`${process.env.REACT_APP_API_URL}/dashboard`, reqData)
        .then((response) => {
          setLoading(false)
          const obj = response.data.data;
          setExpiresOn(obj.expires_on)
          setChecked(obj.is_parental_setting_on == 1 ? true : false)

        });
    } catch (err) {
      setLoading(false)
      // setError(err);
    } finally {
      // setLoading(false);
    }
  };
  /*   const handleAgeCertificate = () => {
      setLoading(true)
      let formData = new FormData();
      formData.append('data[salt]', process.env.REACT_APP_API_SALT);
      formData.append('data[sign]', process.env.REACT_APP_API_SIGN);
      formData.append('data[user_id]', localStorage.getItem('user_id'));
      formData.append('data[age_certi]', parseInt(ac) + 1);
      axios.post(`${process.env.REACT_APP_API_URL}/update-age-certificate`, formData)
        .then((response) => {
          setLoading(false)
          console.log(response.data.VIDEO_STREAMING_APP[0]);
          toast(response.data.VIDEO_STREAMING_APP[0].msg);
        });
      // ${process.env.REACT_APP_API_URL}/update-age-certificate
    }
    const convertDate = (epD) => {
      const ed = new Date(epD * 1000);
      // console.log(ed);
      const month = ed.getMonth();
      const year = ed.getFullYear();
      const date = ed.getDate();
      return `${date}-${month}-${year}`
    } */
  /*   const categories = [
      { value: 1, label: 'U' },
      { value: 2, label: 'U/A 11+' },
      { value: 3, label: 'U/A 13+' },
      { value: 4, label: 'U/A 15+' },
      { value: 5, label: 'A' },
    ];
    const handleChange = (event) => {
      setUserAgeCerti(event.target.value);
      console.log(ageCerti);
    }; */
  return (
    <>
      {
        loading ? (<Loader loading={loading} />) :
          (
            <>
              <Header />
              <Container className='mt-8'>
                <Card style={{ background: "#2a323d" }} className='profile-card'>
                  <Row>
                    <Col md={6}>
                      <Row>

                        <Row>
                          <Col md={8} xs={6}>
                            <p className="card-text-profile mt-5 ml-10"><b>Phone :</b> </p>
                          </Col>
                          <Col md={4} xs={6}>
                            <p className="card-text-profile-value mt-10 ml-10"> {localStorage.getItem('phone') ? localStorage.getItem('phone') : ''}</p>
                          </Col>
                        </Row>


                        <Row>
                          <Col md={8} xs={6}>
                            <p className="card-text-profile mt-5 ml-10"><b>Expires On :</b></p>
                          </Col>
                          <Col md={4} xs={6}>
                            <p className="card-text-profile-value mt-10 ml-10"> {expiresOn}</p>

                          </Col>
                        </Row>


                        <Row>
                          <Col md={8} xs={6}>
                            <p className="card-text-profile mt-5 ml-10"><b>Family Friendly Content :</b>
                            </p>
                          </Col>
                          <Col md={4} xs={6}>
                            <p className='card-text-profile-profile mt-10 ml-10'>

                              <ToggleButton value={checked} onToggle={(value) => { handleParentalSwitch(!value) }} />
                            </p>

                          </Col>
                        </Row>

                      </Row>
                    </Col>

                    <Col md={6}>

                      <TabView>
                        <TabPanel header="Current Plan">
                          <Row>

                            <Row>
                              <Col md={8} xs={6}>
                                <p className="card-text-current-plan"><b>Plan Name:</b> </p>
                              </Col>
                              <Col md={4} xs={6}>
                                <p className="card-text-current-plan-value "> {currentplan.plan_name}</p>
                              </Col>
                            </Row>

                            <Row>
                              <Col md={8} xs={6}>
                                <p className="card-text-current-plan"><b>From Date :</b> </p>
                              </Col>
                              <Col md={4} xs={6}>
                                <p className="card-text-current-plan-value "> {currentplan.from_date}</p>
                              </Col>
                            </Row>

                            <Row>
                              <Col md={8} xs={6}>
                                <p className="card-text-current-plan"><b>To Date :</b> </p>
                              </Col>
                              <Col md={4} xs={6}>
                                <p className="card-text-current-plan-value"> {currentplan.to_date}</p>
                              </Col>
                            </Row>

                            <Row>
                              <Col md={8} xs={6}>
                                <p className="card-text-current-plan"><b>Plan Price :</b> </p>
                              </Col>
                              <Col md={4} xs={6}>
                                <p className="card-text-current-plan-value"> {currentplan.plan_price - currentplan.discount} </p>
                              </Col>
                            </Row>


                          </Row>
                        </TabPanel>
                        <TabPanel header="Upcomming Plans">
                          <p className="m-0">
                            Data Not Available !
                          </p>
                        </TabPanel>

                      </TabView>



                    </Col>

                  </Row>
                </Card>

                {/*  <Splitter style={{ height: '300px' }}>
                  <SplitterPanel className="flex align-items-center justify-content-center" md={6}>
                    <Row>
                      <Col md={12}>
                        <Row>
                          <Col md={4}>
                            <p className="card-text-profile mt-5 ml-10"><b>Phone </b> </p>
                          </Col>
                          <Col md={8}>
                          <p className="card-text-profile mt-5 ml-10"> {localStorage.getItem('phone') ? localStorage.getItem('phone') : ''}</p>
                            
                          </Col>
                        </Row>
                      </Col>
                      <Col md={12}>
                        <Row>
                          <Col md={4}>
                            <p className="card-text-profile mt-5 ml-10"><b>Expires On </b></p>
                          </Col>
                          <Col md={8}>
                          <p className="card-text-profile mt-5 ml-10"> {userData.expires_on}</p>
                           
                          </Col>
                        </Row>
                      </Col>
                      <Col md={12}>
                        <Row>
                          <Col md={4}>
                            <p className="card-text-profile mt-5 ml-10"><b>Family Friendly Content </b>
                            </p>
                          </Col>
                          <Col md={8}>
                          <p className='card-text-profile mt-3 ml-10'>

                          <ToggleButton value={checked} onToggle={(value) => { handleParentalSwitch(!value) }} />
                          </p>
                            
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </SplitterPanel>
                  <SplitterPanel md={6} className="flex align-items-center justify-content-center">


                  <TabView>
    <TabPanel header="Current Plan">
        <p className="m-0">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
            Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
            consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
            Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
        </p>
    </TabPanel>
    <TabPanel header="Upcomming Plans">
        <p className="m-0">
            Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, 
            eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo
            enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui 
            ratione voluptatem sequi nesciunt. Consectetur, adipisci velit, sed quia non numquam eius modi.
        </p>
    </TabPanel>
    
</TabView>


                  </SplitterPanel>
                </Splitter> */}
              </Container>
            </>
          )
      }
      <ToastContainer />
    </>
  )
}
export default Profile